import React from 'react';
import moment from 'moment';

/**
 * EvaluationNavigator — Widget fixo compacto horizontal para navegar entre avaliações.
 * Fica no canto inferior direito, acima do "Powered By".
 */
const EvaluationNavigator = ({ evaluations, selectedIndex, onNavigate }) => {
    if (!evaluations || evaluations.length <= 1) return null;

    const selected = evaluations[selectedIndex];
    const hasPrev = selectedIndex < evaluations.length - 1;
    const hasNext = selectedIndex > 0;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '90px',
                right: '20px',
                zIndex: 9,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '6px',
            }}
        >
            {/* Seta esquerda (mais antiga) */}
            <button
                className="btn btn-sm d-flex align-items-center justify-content-center p-0 border-0"
                onClick={() => onNavigate(1)}
                disabled={!hasPrev}
                style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    background: hasPrev ? 'linear-gradient(135deg, #0f2027, #203a43)' : 'rgba(0,0,0,0.08)',
                    color: hasPrev ? '#fff' : 'rgba(0,0,0,0.2)',
                    transition: 'all 0.2s ease',
                    cursor: hasPrev ? 'pointer' : 'default',
                    boxShadow: hasPrev ? '0 3px 10px rgba(0,0,0,0.3)' : 'none',
                    flexShrink: 0,
                }}
                title="Avaliação mais antiga"
            >
                <i className="mdi mdi-chevron-left" style={{ fontSize: '22px' }}></i>
            </button>

            {/* Pill central: data + contador */}
            <div
                style={{
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    borderRadius: '20px',
                    padding: '6px 14px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                    border: '1px solid rgba(0,0,0,0.08)',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                }}
            >
                <span className="fw-bold text-dark" style={{ fontSize: '13px' }}>
                    {selected?.date ? moment(selected.date).format("DD/MM") : "—"}
                </span>
                <span style={{ fontSize: '11px', color: '#999', fontWeight: '600', marginLeft: '6px' }}>
                    {selectedIndex + 1}/{evaluations.length}
                </span>
            </div>

            {/* Seta direita (mais recente) */}
            <button
                className="btn btn-sm d-flex align-items-center justify-content-center p-0 border-0"
                onClick={() => onNavigate(-1)}
                disabled={!hasNext}
                style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    background: hasNext ? 'linear-gradient(135deg, #0f2027, #203a43)' : 'rgba(0,0,0,0.08)',
                    color: hasNext ? '#fff' : 'rgba(0,0,0,0.2)',
                    transition: 'all 0.2s ease',
                    cursor: hasNext ? 'pointer' : 'default',
                    boxShadow: hasNext ? '0 3px 10px rgba(0,0,0,0.3)' : 'none',
                    flexShrink: 0,
                }}
                title="Avaliação mais recente"
            >
                <i className="mdi mdi-chevron-right" style={{ fontSize: '22px' }}></i>
            </button>
        </div>
    );
};

export default EvaluationNavigator;
